// styles
import styled from "@emotion/styled";
import mixins from "theme/mixins";
import { css } from "@emotion/react";
import { Container } from "./layout";
import Icon from "./icon";

export const StyledTopNavigation = styled.div`
  display: flex;
  height: 60px;

  ${mixins.media.tablet`padding-left: 1rem; padding-right: 1rem;`};

  ${mixins.fontFira()};
  background-color: ${(props) => props.theme.white};
  a {
    font-weight: 300;
  }
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledLogo = styled.div`
  height: 60px;
  width: 120px;
  cursor: pointer;
`;

export const StyledToggle = styled.div`
  align-items: center;
  justify-content: center;

  cursor: pointer;
  display: none;
  ${mixins.media.tablet`display: flex;`};
`;

export const StyledBars = styled(Icon)`
  pointer-events: none;
`;

interface CollapseProps {
  $isOpen: boolean;
}

export const StyledCollapse = styled.div<CollapseProps>(
  ({ $isOpen }) => css`
    display: flex;
    align-items: center;
    gap: 1rem;

    ${mixins.media.tablet`
      display: none;
    `}

    ${$isOpen &&
    mixins.media.tablet`
        display: flex;
        position: fixed;
        top: 60px;
        bottom: 0;
        z-index: 99;
        left: 0;
        right: 0;
        background-color: white;
        flex-direction: column;
        padding: 1rem 0;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      `}
  `,
);

export const StyledLink = styled.div<{ $match: boolean }>`
  cursor: pointer;
  ${(props) =>
    props.$match &&
    css`
      border-bottom: 3px solid ${props.theme.blue};
    `}
`;
